import React, { useState, useEffect, useContext, createContext } from "react";
import Select from "react-select";
import {
    fetchedGangs,
    fetchedMatrix,
    fetchedRoute,
    sendOperationData,
} from "../../../apis/apis.logistics/apisProduct";
import { fetchedStockInOneWarehouse } from "../../../apis/apis.buys/apisPurchase";
import { toast } from "react-toastify";
import { ContextAuth } from "../../../contexts/ContextAuth";

import { operationDocumentTypes, persons } from "../../../configs/Data";

const initialSelectedProductState = {
    productID: "",
    productName: "",
    productCode: "",
    grammage: "",
    sku: "",
    unitName: "",
    tariffs: [],
    price: "0",
    quantity: "0",
    typeTradeID: "1",
    subtotal: "0",
    stock: "0",
    productTariffID: "0",
};

export function SpecialSaleForm({
    registerData,
    setRegisterData,
    clients,
    setClients,
    products,
    setProducts,
    clearRegisterDataState,
    searchSuggestions,
}) {
    const { auth } = useContext(ContextAuth);
    const [loading, setLoading] = useState(false);
    const [gangs, setGangs] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(
        initialSelectedProductState
    );
    // 1. Agrega un estado para el valor seleccionado del Select de productos
    const [selectedProductOption, setSelectedProductOption] = useState(null);

    const [formError, setFormError] = useState("");
    const [visitDay, setVisitDay] = useState(""); // Nuevo estado para el día de visita
    const visitDays = [
        { value: 0, label: "LUNES" },
        { value: 1, label: "MARTES" },
        { value: 2, label: "MIERCOLES" },
        { value: 3, label: "JUEVES" },
        { value: 4, label: "VIERNES" },
        { value: 5, label: "SABADO" },
        { value: 6, label: "DOMINGO" },
    ];

    const clearSelectedProductState = () => {
        setSelectedProduct({
            ...selectedProduct,
            productID: "",
            productName: "",
            productCode: "",
            grammage: "",
            sku: "",
            unitName: "",
            tariffs: [],
            price: "0",
            quantity: "0",
            subtotal: "0",
            stock: "0",
            productTariffID: "0",
        });
        setSelectedProductOption(null); // Limpia el Select visualmente
    };

    const sendOperation = async () => {
        try {
            const response = await sendOperationData(registerData);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const handleChangeOperationClient = (selectOption) => {
        let foundClient = clients.find(
            (c) => Number(c.value) === Number(selectOption.value)
        );
        setRegisterData({
            ...registerData,
            clientID: selectOption.value,
            clientName: selectOption.label,
            operationDocumentTypeID:
                foundClient.documentType === "01" ? "02" : "03",
        });
    };

    const handleChangePriceAndQuantityBox = (e) => {
        let subtotal = document.getElementById("subtotal");
        if (e.target.name == "price") {
            subtotal =
                Number(selectedProduct.quantity) * Number(e.target.value);
            setSelectedProduct({
                ...selectedProduct,
                price: e.target.value,
                subtotal: subtotal.toFixed(2),
            });
        } else if (e.target.name == "quantity") {
            if (Number(e.target.value) <= selectedProduct.stock) {
                subtotal =
                    Number(selectedProduct.price) * Number(e.target.value);
                setSelectedProduct({
                    ...selectedProduct,
                    quantity: e.target.value,
                    subtotal: subtotal.toFixed(2),
                });
            }
        }
    };

    async function handleButtonRemove(item) {
        setRegisterData({
            ...registerData,
            details: registerData.details.filter(function (obj) {
                return (
                    obj.productID
                        .toString()
                        .concat(obj.productTariffID.toString()) !==
                    item.productID
                        .toString()
                        .concat(item.productTariffID.toString())
                );
            }),
            operationAmountBase:
                registerData.details.length > 1
                    ? Number(
                          Number(registerData.operationAmountBase) -
                              item.subtotal
                      ).toFixed(2)
                    : "0",
            operationAmountTotal:
                registerData.details.length > 1
                    ? Number(
                          Number(registerData.operationAmountBase) -
                              item.subtotal
                      ).toFixed(2)
                    : "0",
            operationAmountIgv: "0",
        });
    }

    const handleButtonAdd = () => {
        const found = registerData.details.find(function (detail, index) {
            if (detail.productTariffID == selectedProduct.productTariffID)
                return true;
        });

        if (!found) {
            if (Number(selectedProduct.productID) > 0) {
                if (
                    Number(selectedProduct.price) > 0 &&
                    Number(selectedProduct.quantity) > 0
                ) {
                    setRegisterData((prevState) => ({
                        ...prevState,
                        details: [...prevState.details, selectedProduct], // add new expense to expenses array
                        // operationAmountBase: Number(registerData.operationAmountBase) + Number(selectedProduct.subtotal), // reset this field
                        // operationAmountIgv: "0", // reset this field
                        // operationAmountTotal: Number(Number(registerData.operationAmountBase) + Number(selectedProduct.subtotal)).toFixed(2), // reset this field
                    }));
                    // document.getElementById("operationAmountIgv").value = "0";

                    clearSelectedProductState();
                } else {
                    toast.error("Verifique cantidad y precio");
                }
            } else {
                toast.info("Elija un producto");
            }
        } else {
            toast.info("Ya existe este item");
        }
    };

    useEffect(() => {
        calculateTotal();
    }, [registerData.details]);

    function calculateTotal() {
        const totalDiscountedSubtotal = registerData?.details?.reduce(
            (total, detail) => {
                const quantityReturned = Number(detail.quantity);
                const price = Number(detail.price);
                const subtotal = quantityReturned * price;
                return total + subtotal;
            },
            0
        );

        let total = totalDiscountedSubtotal;
        let base = total / 1.18;
        let igv = total - base;

        setRegisterData((prevState) => ({
            ...prevState,
            operationAmountBase: Number(base).toFixed(2), // reset this field
            operationAmountIgv: Number(igv).toFixed(2), // reset this field
            operationAmountTotal: Number(total).toFixed(2), // reset this field
        }));
    }

    const isValidFactura = (docType, docNumber) =>
        docType === "06" && docNumber.length === 11;

    const isValidBoleta = (docType, docNumber) =>
        (docType === "01" && docNumber.length === 8) ||
        (docType === "06" && docNumber.length === 11);

    const handleClickBtnSave = async () => {
        setFormError(""); // Limpia errores previos

        if (!registerData.clientID || registerData.clientID === "0") {
            setFormError("Debe seleccionar un cliente.");
            return;
        }

        const selectedClient = clients.find(
            (c) => String(c.value) === String(registerData.clientID)
        );
        const docNumber = selectedClient?.label?.split(":")?.[1]?.trim() || "";
        const docType = selectedClient?.documentType;

        // Validación de documento según tipo de comprobante
        if (
            registerData.operationDocumentTypeID === "03" &&
            !isValidFactura(docType, docNumber)
        ) {
            setFormError(
                "Para FACTURA el cliente debe tener RUC (11 dígitos)."
            );
            return;
        }
        if (
            registerData.operationDocumentTypeID === "02" &&
            !isValidBoleta(docType, docNumber)
        ) {
            setFormError(
                "Para BOLETA el cliente debe tener DNI (8 dígitos) o RUC (11 dígitos)."
            );
            return;
        }

        if (!registerData.details.length) {
            toast.error("Verifique los items a registrar");
            return;
        }
        if (registerData.operationTypeID === "NA") {
            toast.error("Verifique el tipo de operacion");
            return;
        }
        if (registerData.warehouseID === "0") {
            toast.error("Verifique el almacen");
            return;
        }
        if (registerData.clientID === "0") {
            toast.error("Verifique el cliente");
            return;
        }

        setLoading(true);
        try {
            const r = await sendOperation();
            if (r.status === 201) {
                toast.success("Operacion registrada con exito!");
                clearRegisterDataState();
                searchSuggestions();
                setProducts([]);
                getProducts({ warehouseID: 3 });
            } else {
                toast.error("Ocurrio algun error");
            }
        } catch (error) {
            toast.error("Ocurrio algun error");
        } finally {
            setLoading(false);
            document.getElementById("btn-close-modal-register").click();
        }
    };

    const getRoute = async (data) => {
        try {
            const response = await fetchedRoute(data);

            response.forEach((client) => {
                setClients((prevState) => [
                    ...prevState,
                    {
                        value: client["personID"],
                        label: `${client["observation"]} | ${client["fullName"]} | ${client["documentTypeDisplay"]}: ${client["documentNumber"]}`,
                        routeDate: client["routeDate"],
                        documentType: client["documentType"],
                    },
                ]); // add new expense to expenses array
            });

            return response;
        } catch (error) {
            throw error;
        }
    };

    const handleChangeOperation = (e) => {
        if (e.target.name === "typeTradeID") {
            const foundProduct = products.find(
                (product) =>
                    Number(product.productID) ==
                    Number(selectedProduct.productID)
            );
            console.log(foundProduct);
            let selectedPrice = 0;
            // let selectedProductTariffID = foundProduct["tariffs"][0]["productTariffID"];
            if (e.target.value === "1")
                selectedPrice = foundProduct["tariffs"][0]["priceSale"];
            else if (e.target.value === "2")
                selectedPrice =
                    foundProduct["tariffs"][0]["priceSaleWholesale"];
            else if (e.target.value === "3")
                selectedPrice = foundProduct["tariffs"][0]["priceSalePrimax"];
            else if (e.target.value === "4")
                selectedPrice = foundProduct["tariffs"][0]["priceSaleSunat"];

            setSelectedProduct({
                ...selectedProduct,
                // tariffs: selectOption.tariff,
                typeTradeID: e.target.value,
                // productID: "0",
                // productTariffID: selectedProductTariffID,

                // productName: "",
                // grammage: selectOption.grammage,
                // sku: "",
                // stock: 0,
                price: Number(selectedPrice),
                // price: selectOption.tariff[0].price,
                subtotal: Number(
                    Number(selectedPrice) * Number(selectedProduct.quantity)
                ).toFixed(2),
                // productTariffID: selectOption.tariff[0].productTariffID,
                // unitName: selectOption.tariff[0].unitName,
            });
            // setRegisterData({ ...registerData, [e.target.name]: e.target.value });
        }
    };

    const handleChangeProductBox = async (selectOption) => {
        let selectedPrice = 0;
        // let selectedProductTariffID = foundProduct["tariffs"][0]["productTariffID"];
        if (selectedProduct.typeTradeID === "1")
            selectedPrice = selectOption["tariffs"][0]["priceSale"];
        else if (selectedProduct.typeTradeID === "2")
            selectedPrice = selectOption["tariffs"][0]["priceSaleWholesale"];
        else if (selectedProduct.typeTradeID === "3")
            selectedPrice = selectOption["tariffs"][0]["priceSalePrimax"];
        else if (selectedProduct.typeTradeID === "4")
            selectedPrice = selectOption["tariffs"][0]["priceSaleSunat"];

        setSelectedProduct({
            ...selectedProduct,
            // tariffs: selectOption.tariff,
            productID: selectOption.productID,
            productTariffID: selectOption.productTariffID,

            productCode: selectOption.productCode,
            productName: selectOption.productSaleName,
            // grammage: selectOption.grammage,
            sku: selectOption.sku,
            stock: selectOption.stock >= 0 ? selectOption.stock : 0,
            // price: selectOption.price >= 0 ? selectOption.price : 0,
            price: selectedPrice,
            // price: selectOption.tariff[0].price,
            // subtotal: Number(Number(selectOption.price) * Number(selectOption.quantity)).toFixed(2),
            // productTariffID: selectOption.tariff[0].productTariffID,
            // unitName: selectOption.tariff[0].unitName,
        });

        console.log(selectOption);
    };

    const getProducts = async (data) => {
        try {
            const response = await fetchedStockInOneWarehouse(data);
            response.forEach((product) => {
                setProducts((prevState) => [
                    ...prevState,
                    {
                        value: product["productID"],
                        label:
                            product["productCode"] +
                            " | " +
                            product["productSaleName"],
                        stock: product["stockA"],
                        price: product["priceSale"],
                        tariffs: product["remainingQuantityInTariffs"],
                        productID: product["productID"],
                        productCode: product["productCode"],
                        productSaleName: product["productSaleName"],
                        productTariffID: product["productTariffID"],
                        sku: product["productSku"],
                    },
                ]); // add new expense to expenses array
            });

            return response;
        } catch (error) {
            throw error;
        }
    };

    const getWarehouses = async () => {
        try {
            const response = await fetchedGangs();
            setGangs(response);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const handleChangeOperationWarehouse = (e) => {
        // setProducts([]);
        const found = gangs.find(function (gang, index) {
            if (gang.gangID == e.target.value) return true;
        });
        if (found) {
            setRegisterData({
                ...registerData,
                // warehouseID: found.warehouseID,
                gangID: found.gangID,
                // warehouseName: found.warehouseName,
                // operationDate: operationDate,
                clientID: "0",
                // warehouseCategory: found.warehouseCategory,
                userID: auth.data.user_id,
            });
        }
        // getCLientsAndProducts(e.target.value, registerData.operationDate);
    };

    useEffect(() => {
        if (
            Number(registerData.gangID) > 0 &&
            visitDay !== "" &&
            clients.length === 0
        ) {
            getRoute({
                gangID: registerData.gangID,
                visitDay: Number(visitDay),
            });
        }
    }, [clients, visitDay]);

    useEffect(() => {
        setClients([]);
    }, [registerData.gangID, visitDay]);

    useEffect(() => {
        if (auth.data.user_id != undefined) {
            getWarehouses();
            getProducts({ warehouseID: 3 }); // A-1 Almacen Central
            setRegisterData({
                ...registerData,
                userID: auth.data.user_id,
            });
        } else {
            toast.error("Problemas con la obtencion del usuario");
        }
    }, []);
    useEffect(() => {
        const modal = document.getElementById("modal-register-sale-operation");
        const clearErrorOnOpen = () => setFormError("");
        if (modal) {
            modal.addEventListener("show.bs.modal", clearErrorOnOpen);
            return () =>
                modal.removeEventListener("show.bs.modal", clearErrorOnOpen);
        }
    }, []);
    return (
        <div className="modal fade" id="modal-register-sale-operation">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header bg-primary text-white">
                        <h4 className="modal-title">
                            <i className="fas fa-shopping-cart mr-2"></i>
                            Registrar Venta
                        </h4>
                        <button
                            type="button"
                            className="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body bg-light">
                        <div className="card shadow-sm mb-4">
                            <div className="card-body">
                                <div
                                    className="alert alert-info mb-4"
                                    role="alert"
                                >
                                    <i className="fas fa-info-circle mr-2"></i>
                                    <strong>Nota:</strong>
                                    <ul className="mb-0 mt-2">
                                        <li>
                                            Los clientes aparecerán según se
                                            escoja la ruta y la fecha (día de
                                            visita)
                                        </li>
                                        <li>
                                            Los productos mostrados pertenecen
                                            al almacén central
                                        </li>
                                        <li>Los precios son editables</li>
                                        <li>
                                            La fecha de operación es la fecha
                                            actual
                                        </li>
                                    </ul>
                                </div>
                                <h5 className="mb-3">Datos de la venta</h5>
                                <hr />
                                {formError && (
                                    <div className="alert alert-danger">
                                        {formError}
                                    </div>
                                )}
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="font-weight-bold text-muted">
                                                <i className="fas fa-route mr-2"></i>
                                                Grupo / (Ruta)
                                            </label>
                                            <select
                                                className="form-control form-control-lg"
                                                id="gangID111"
                                                name="gangID"
                                                onChange={
                                                    handleChangeOperationWarehouse
                                                }
                                                value={registerData.gangID}
                                            >
                                                <option value="0">
                                                    Elegir
                                                </option>
                                                {gangs.map((item, index) => {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={item.gangID}
                                                        >
                                                            {item.gangName} |{" "}
                                                            {item.warehouseName}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="font-weight-bold text-muted">
                                                <i className="fas fa-calendar-day mr-2"></i>
                                                Día de visita
                                            </label>
                                            <select
                                                id="visitDay111"
                                                name="visitDay"
                                                className="form-control form-control-lg"
                                                value={visitDay}
                                                onChange={(e) =>
                                                    setVisitDay(e.target.value)
                                                }
                                            >
                                                <option value="">
                                                    Elegir día
                                                </option>
                                                {visitDays.map((day) => (
                                                    <option
                                                        key={day.value}
                                                        value={day.value}
                                                    >
                                                        {day.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex  align-items-end">
                                    <div className="form-group w-100">
                                        <label htmlFor="clientID111">
                                            Cliente
                                        </label>

                                        {clients.length ? (
                                            <Select
                                                options={clients}
                                                onChange={
                                                    handleChangeOperationClient
                                                }
                                                placeholder="Buscar o seleccionar cliente..."
                                                isSearchable
                                            />
                                        ) : (
                                            <select
                                                className="form-control"
                                                disabled
                                            >
                                                <option disabled>
                                                    Seleccione
                                                </option>
                                            </select>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex align-items-start">
                                    <div className="form-group">
                                        <label htmlFor="operationDate111">
                                            <i className="fas fa-calendar-alt mr-2"></i>
                                            Fecha de venta
                                        </label>
                                        <input
                                            type="date"
                                            id="operationDate111"
                                            name="operationDate"
                                            className="form-control"
                                            value={registerData.operationDate}
                                            onChange={(e) =>
                                                setRegisterData({
                                                    ...registerData,
                                                    operationDate:
                                                        e.target.value,
                                                })
                                            }
                                            placeholder="Selecciona la fecha de venta"
                                            max={
                                                new Date()
                                                    .toISOString()
                                                    .split("T")[0]
                                            }
                                        />
                                        <small className="form-text text-muted">
                                            La fecha de operación es la fecha
                                            actual o anterior. No se permiten
                                            fechas futuras.
                                        </small>
                                    </div>
                                    <div className="form-group ml-3">
                                        <label htmlFor="operationDocumentTypeID111">
                                            Tip. Doc.
                                            <span
                                                data-toggle="tooltip"
                                                title="Tipo de documento para la operación."
                                                style={{
                                                    cursor: "pointer",
                                                    marginLeft: 5,
                                                }}
                                            >
                                                <i className="fas fa-question-circle text-info"></i>
                                            </span>
                                        </label>
                                        <select
                                            className={`form-control text-uppercase ${
                                                !registerData.operationDocumentTypeID
                                                    ? "is-invalid"
                                                    : ""
                                            }`}
                                            id="operationDocumentTypeID111"
                                            name="operationDocumentTypeID"
                                            onChange={(e) => {
                                                setRegisterData({
                                                    ...registerData,
                                                    operationDocumentTypeID:
                                                        e.target.value,
                                                });
                                            }}
                                            value={
                                                registerData.operationDocumentTypeID
                                            }
                                        >
                                            <option value="" disabled>
                                                Selecciona tipo de documento
                                            </option>
                                            {operationDocumentTypes.map(
                                                (item, index) => {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </select>
                                        {!registerData.operationDocumentTypeID && (
                                            <div className="invalid-feedback">
                                                Debe seleccionar un tipo de
                                                documento.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card shadow-sm">
                            <div className="card-body">
                                {/* Sección de ingreso de productos */}
                                <div
                                    className="card mb-3 p-3 border border-primary rounded"
                                    style={{ background: "#f8fafd" }}
                                >
                                    <div className="row align-items-end">
                                        <div className="col-12 col-md-6 mb-2">
                                            <label className="font-weight-bold">
                                                Producto
                                            </label>
                                            {products.length ? (
                                                <div className="d-flex align-items-center">
                                                    <Select
                                                        options={products}
                                                        value={
                                                            selectedProductOption
                                                        }
                                                        onChange={(option) => {
                                                            setSelectedProductOption(
                                                                option
                                                            );
                                                            handleChangeProductBox(
                                                                option
                                                            );
                                                        }}
                                                        placeholder="Buscar o seleccionar producto..."
                                                        isSearchable
                                                        className="w-100"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary btn-sm ml-2"
                                                        title="Limpiar selección"
                                                        onClick={
                                                            clearSelectedProductState
                                                        }
                                                    >
                                                        <i className="fas fa-times"></i>
                                                    </button>
                                                </div>
                                            ) : (
                                                <select
                                                    className="form-control"
                                                    disabled
                                                ></select>
                                            )}
                                        </div>
                                        <div className="col-6 col-md-3 mb-2">
                                            <label className="font-weight-bold">
                                                Tipo Precio
                                            </label>
                                            <select
                                                className="form-control"
                                                name="typeTradeID"
                                                onChange={handleChangeOperation}
                                                value={
                                                    selectedProduct.typeTradeID
                                                }
                                            >
                                                <option value="1">
                                                    P. V. (Tiendas)
                                                </option>
                                                <option value="2">
                                                    P. V. Mayorista
                                                </option>
                                                <option value="3">
                                                    P. V. Grifo Primax
                                                </option>
                                                <option value="4">
                                                    P. V. para Sunat
                                                </option>
                                            </select>
                                        </div>
                                        <div className="col-6 col-md-3 mb-2">
                                            <label className="font-weight-bold">
                                                Stock
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="stock"
                                                id="stock"
                                                value={selectedProduct.stock}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="row align-items-end">
                                        <div className="col-6 col-md-3 mb-2">
                                            <label className="font-weight-bold">
                                                Precio
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="price"
                                                placeholder="Precio"
                                                value={selectedProduct.price}
                                                onChange={
                                                    handleChangePriceAndQuantityBox
                                                }
                                                maxLength={6}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div className="col-6 col-md-3 mb-2">
                                            <label className="font-weight-bold">
                                                Cantidad
                                            </label>
                                            <input
                                                type="number"
                                                className={`form-control text-center ${
                                                    Number(
                                                        selectedProduct.quantity
                                                    ) >
                                                    Number(
                                                        selectedProduct.stock
                                                    )
                                                        ? "is-invalid"
                                                        : ""
                                                }`}
                                                name="quantity"
                                                placeholder="Cantidad"
                                                value={selectedProduct.quantity}
                                                onChange={
                                                    handleChangePriceAndQuantityBox
                                                }
                                                onFocus={(e) =>
                                                    e.target.select()
                                                }
                                                maxLength={6}
                                            />
                                            {Number(selectedProduct.quantity) >
                                                Number(
                                                    selectedProduct.stock
                                                ) && (
                                                <div className="invalid-feedback">
                                                    La cantidad no puede superar
                                                    el stock disponible.
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-6 col-md-3 mb-2">
                                            <label className="font-weight-bold">
                                                Subtotal
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control text-right"
                                                name="subtotal"
                                                id="subtotal"
                                                placeholder=""
                                                value={selectedProduct.subtotal}
                                                onChange={
                                                    handleChangePriceAndQuantityBox
                                                }
                                                readOnly
                                                maxLength={6}
                                            />
                                        </div>
                                        <div className="col-6 col-md-3 mb-2 d-flex align-items-end">
                                            <button
                                                className="btn btn-success btn-block mt-md-4"
                                                onClick={handleButtonAdd}
                                            >
                                                Agregar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/* Tabla de detalles */}
                                <table className="table table-hover table-bordered">
                                    <thead className="bg-light">
                                        <tr className="text-center text-uppercase">
                                            <th
                                                scope="col"
                                                style={{ width: "10%" }}
                                            >
                                                ID
                                            </th>
                                            <th
                                                scope="col"
                                                style={{ width: "30%" }}
                                            >
                                                Producto
                                            </th>
                                            <th
                                                scope="col"
                                                style={{ width: "10%" }}
                                            >
                                                Stock
                                            </th>
                                            <th
                                                scope="col"
                                                style={{ width: "15%" }}
                                            >
                                                Tipo Precio
                                            </th>
                                            <th
                                                scope="col"
                                                style={{ width: "15%" }}
                                            >
                                                Precio
                                            </th>
                                            <th
                                                scope="col"
                                                style={{ width: "10%" }}
                                            >
                                                Cantidad
                                            </th>
                                            <th
                                                scope="col"
                                                style={{ width: "15%" }}
                                            >
                                                Subtotal
                                            </th>
                                            <th
                                                scope="col"
                                                style={{ width: "10%" }}
                                            >
                                                Acciones
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {registerData.details.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={8}
                                                    className="text-center text-muted"
                                                >
                                                    No hay productos agregados
                                                    aún.
                                                </td>
                                            </tr>
                                        ) : (
                                            registerData.details.map(
                                                (item, index) => {
                                                    return (
                                                        <tr
                                                            key={index}
                                                            value={
                                                                item.productTariffID
                                                            }
                                                            className="detalle-fila"
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                            onMouseOver={(e) =>
                                                                (e.currentTarget.style.backgroundColor =
                                                                    "#f0f8ff")
                                                            }
                                                            onMouseOut={(e) =>
                                                                (e.currentTarget.style.backgroundColor =
                                                                    "")
                                                            }
                                                        >
                                                            <td className="text-center align-middle">
                                                                {
                                                                    item.productCode
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle">
                                                                {
                                                                    item.productName
                                                                }
                                                            </td>
                                                            <td className="text-center align-middle">
                                                                {item.stock}
                                                            </td>
                                                            <td className="text-center align-middle">
                                                                {
                                                                    item.typeTradeID
                                                                }
                                                            </td>
                                                            <td className="text-center align-middle">
                                                                {item.price}
                                                            </td>
                                                            <td className="text-center align-middle">
                                                                {item.quantity}
                                                            </td>
                                                            <td className="text-right align-middle">
                                                                S/{" "}
                                                                {item.subtotal}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-warning btn-block"
                                                                    onClick={() =>
                                                                        handleButtonRemove(
                                                                            item
                                                                        )
                                                                    }
                                                                >
                                                                    Quitar
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )
                                        )}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td
                                                colSpan={6}
                                                className="text-right font-weight-bold"
                                            >
                                                OP. GRAVADAS
                                            </td>
                                            <td className="text-right font-weight-bold text-nowrap">
                                                S/{" "}
                                                {
                                                    registerData.operationAmountBase
                                                }
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td
                                                colSpan={6}
                                                className="text-right font-weight-bold"
                                            >
                                                IGV
                                            </td>
                                            <td className="text-right font-weight-bold text-nowrap">
                                                S/{" "}
                                                {
                                                    registerData.operationAmountIgv
                                                }
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td
                                                colSpan={6}
                                                className="text-right font-weight-bolder"
                                            >
                                                TOTAL
                                            </td>
                                            <td className="text-right font-weight-bolder text-nowrap">
                                                S/{" "}
                                                {
                                                    registerData.operationAmountTotal
                                                }
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer  justify-content-end px-4">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                            id="btn-close-modal-register"
                        >
                            Cerrar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleClickBtnSave}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm mr-2"></span>
                                    Guardando...
                                </>
                            ) : (
                                "Registrar"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
